import {api} from '../../system/api';

export default {
    fetchLocation: () => api.get('locations', {}, {singleRequest: true}),
    fetchCountry: (params) => api.get('locations/' + params + '/children', {}, {singleRequest: true})
};
